import React from "react";
import ClarkMachineCard from "./clarkMachineCard";
import PalletCard from "./palletCard";

const PalletTrucks = () => {
  return (
    <div className="w-full mt-5">
      <h4 className="mt-8 text-xl">Ruční paletové vozíky</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <PalletCard
          imgSrc="/images/ClarkOverview/clark-hpt-cpj25.webp"
          imgAlt="Obrázek ručního paletového vozíku CLARK hpt-cpj25"
          title="CLARK HPT CPJ25"
          loadCapacity="2 500 kg"
          liftHeight="115 mm"
          control="Ruční"
          link="https://clarkmheu-com.translate.goog/en/hand-pallet-trucks/hpt-cpj25?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <PalletCard
          imgSrc="/images/ClarkOverview/clark-hpt-premium.webp"
          imgAlt="Obrázek ručního paletového vozíku CLARK hpt-premium"
          title="CLARK HPT Premium"
          loadCapacity="2 500 kg"
          liftHeight="115 mm"
          control="Ruční s rychlozdvihem nebo bez něj"
          link="https://clarkmheu-com.translate.goog/en/hand-pallet-trucks/hpt-premium?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
      </div>

      <h4 className="mt-8 text-xl">Paletové vozíky s lithium-iontovou baterií</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-lwio15.webp"
          imgAlt="Obrázek paletového lion vozíku CLARK lwio15"
          title="CLARK LWio15"
          loadCapacity="1 500 kg"
          drive="Elektrický"
          liftHeight="105 mm"
          maxSpeed="až 4.5 km/h"
          link="https://clarkmheu-com.translate.goog/en/li-ion-pallet-trucks/lwio15?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-wpio15.webp"
          imgAlt="Obrázek paletového lion vozíku CLARK wpio15"
          title="CLARK WPio15"
          loadCapacity="1 500 kg"
          drive="Elektrický"
          liftHeight="115 mm"
          maxSpeed="až 4.5 km/h"
          link="https://clarkmheu-com.translate.goog/en/li-ion-pallet-trucks/wpio15?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-wpio18.webp"
          imgAlt="Obrázek paletového lion vozíku CLARK wpio18"
          title="CLARK WPio18"
          loadCapacity="1 800 kg"
          drive="Elektrický"
          liftHeight="115 mm"
          maxSpeed="až 5.5 km/h"
          link="https://clarkmheu-com.translate.goog/en/li-ion-pallet-trucks/wpio18?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-pwio20.webp"
          imgAlt="Obrázek paletového lion vozíku CLARK pwio20"
          title="CLARK PWio20"
          loadCapacity="2 000 kg"
          drive="Elektrický"
          liftHeight="207 mm"
          maxSpeed="až 5.5 km/h"
          link="https://clarkmheu-com.translate.goog/en/li-ion-pallet-trucks/pwio20?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
      </div>

      <h4 className="mt-8 text-xl">Elektrické paletové vozíky</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-wpx20.webp"
          imgAlt="Obrázek paletového elektrického vozíku CLARK wpx20"
          title="CLARK WPX20"
          loadCapacity="2 000 kg"
          drive="Elektrický"
          liftHeight="205 mm"
          maxSpeed="až 6 km/h"
          additionalInfo="Volitelně s lithium-iontovou baterií"
          link="https://clarkmheu-com.translate.goog/en/pallet-trucks/wpx20?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-ppxs20.webp"
          imgAlt="Obrázek paletového elektrického vozíku CLARK ppxs20"
          title="CLARK PPXS20"
          loadCapacity="2 000 kg"
          drive="Elektrický"
          liftHeight="120 mm"
          maxSpeed="až 12 km/h"
          additionalInfo="Volitelně s lithium-iontovou baterií"
          link="https://clarkmheu-com.translate.goog/en/pallet-trucks/ppxs20?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-ppfxs20.webp"
          imgAlt="Obrázek paletového elektrického vozíku CLARK ppfxs20"
          title="CLARK PPFXS20"
          loadCapacity="2 000 kg"
          drive="Elektrický"
          liftHeight="120 mm"
          maxSpeed="až 10 km/h"
          additionalInfo="Volitelně s lithium-iontovou baterií"
          link="https://clarkmheu-com.translate.goog/en/pallet-trucks/ppfxs?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
      </div>
    </div>
  );
};
export default PalletTrucks;
